function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.314 0h-.622L0 16.358l.435.58.108-.037 4.4-6.15L12 .875l10.678 14.94-10.551-3.724h-.254l-9.308 3.29-.766 1.074L12 12.85l11.565 4.08.435-.579L12.314 0z"
});
function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgLocation;